/* eslint-disable no-restricted-imports */
import React from 'react';

import { useIsNonInteractiveViewer } from '@app/ui';
import useContentVariant from './hooks/useContentVariant';
import ContentWrapper from './components/ContentWrapper';

import Auth from './variants/Auth';
import BuySell from './variants/BuySell';
import Bot from './variants/Bot';
import Human from './variants/Human';
import Favorites from './variants/Favorites';

const VARIANTS = {
  auth: Auth,
  buysell: BuySell,
  human: Human,
  favorites: Favorites, // mobile only
};

const StaticContent = () => (
  <ContentWrapper>
    <Bot />
  </ContentWrapper>
);

const SiteContent = () => {
  const variant = useContentVariant();
  const HeaderContentComponent = VARIANTS[variant];
  // check if the url is list favorite, then we have a separate one
  return (
    <ContentWrapper>
      <HeaderContentComponent />
    </ContentWrapper>
  );
};

const Content = () => {
  const isNonInteractiveViewer = useIsNonInteractiveViewer();

  if (isNonInteractiveViewer) {
    return <StaticContent />;
  }

  return <SiteContent />;
};

export default Content;
